// Storage adapter interface. Every implementation provides:
//   loadEnquiries():            Promise<Enquiry[]>      (with remarks attached)
//   loadOrgSettings():          Promise<{ sources: string[] }>
//   createEnquiry(rec):         Promise<void>
//   updateEnquiry(id, patch):   Promise<void>
//   deleteEnquiry(id):          Promise<void>
//   addRemark(enquiryId, r):    Promise<void>
//   updateOrgSettings(patch):   Promise<void>
//
// The engine keeps an optimistic in-memory copy and calls these in the
// background — implementations must throw on failure so onError fires.

// Demo implementation: serves seed data, persists nothing.
// Refresh wipes everything — intentional for the Phase A demo.
export const createMemoryStorage = (seedEnquiries = [], seedSettings = { sources: [] }) => ({
  loadEnquiries: async () => seedEnquiries.map((e) => ({ ...e })),
  loadOrgSettings: async () => ({ ...seedSettings }),
  createEnquiry: async () => {},
  updateEnquiry: async () => {},
  deleteEnquiry: async () => {},
  addRemark: async () => {},
  updateOrgSettings: async () => {},
});
